import { MainV3ApiBase } from './base';
import {
    MonthlyGoal,
    MonthlyGoalIndex,
    IdealCareer,
    YearlyGoal,
    LongTermGoal,
    MonthlyGoalSummary,
} from '../types/goals';

export const GoalsApi = {
    base() {
        return MainV3ApiBase.appendPath('users/current/goals');
    },
    findAllMonthlyGoals(): Promise<MonthlyGoalIndex[]> {
        return this.base()
            .appendPath('monthly')
            .get();
    },
    findMonthlyGoal(year: number, month: number): Promise<MonthlyGoal> {
        return this.base()
            .appendPath('monthly')
            .withId(year)
            .withId(month)
            .get();
    },
    findMonthlyGoalSummary(): Promise<MonthlyGoalSummary> {
        return this.base()
            .appendPath('monthly')
            .appendPath('summary')
            .get();
    },
    updateMonthlyGoal(formData: MonthlyGoal): Promise<void> {
        return this.base()
            .appendPath('monthly')
            .put(formData);
    },
    findIdealCareer(): Promise<IdealCareer> {
        return this.base()
            .appendPath('ideal_career')
            .get();
    },
    updateIdealCareer(formData: FormData): Promise<void> {
        return this.base()
            .appendPath('ideal_career')
            .putForm(formData);
    },
    findYearlyGoal(): Promise<YearlyGoal> {
        return this.base()
            .appendPath('yearly')
            .get();
    },
    updateYearlyGoal(formData: FormData): Promise<void> {
        return this.base()
            .appendPath('yearly')
            .putForm(formData);
    },
    findLongTermGoal(): Promise<LongTermGoal> {
        return this.base()
            .appendPath('long_term')
            .get();
    },
};
